module.exports = __webpack_public_path__ + "img/home.ac3e3ef0.svg";